<template>
  <div class="vcontainer">

    <div id="top-contain" class="top-contain">
      <div class="top-left" @click="close">
        <img class="back-icon-big" src="../assets/index/icon_white copy.png" />
        <div class="title">{{pageTitle}}</div>
      </div>
      <div class="top-left">
        <div class="content" @click="more">查看更多</div>
        <img class="back-icon" src="../assets/index/ic_right.png" />
      </div>
    </div>
    <van-swipe ref="vanswipe" :show-indicators="false" :touchable="false" id="infeed-swipe" class="infeed-swipe"
      :loop="false" @change="onChange">
      <!-- 投诉 -->
      <van-swipe-item v-if="authData.complainlimitState.complaintLeader">
        <div id="main1" class="infeed-contain">
          <div class="body-contain">
            <div class="left-body">
              <div class="left-title">实时投诉数据</div>
              <!--领导组-->
              <template v-if="authData.complainlimitState.complaintLeader">
                <div class="box">
                  <div v-for="(item,index) in complaintData.handling" :key="index" class="left">
                    <div>
                      <div class="num-name">{{item.name}}</div>
                      <div class="num">
                        <p class="big">{{item.value}}</p>
                        <p class="small">起</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!--处理组-->
              <template v-if="authData.complainlimitState.complaintHandlder && complaintData.IfComplaintHandling">
                <div class="box">
                  <div v-for="(item,index) in complaintData.handleWorkbench" :key="index" class="left">
                    <div>
                      <div class="num-name">{{item.name}}</div>
                      <div class="num">
                        <p class="big">{{item.count}}</p>
                        <p class="small">起</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div style="height:100px;"></div>
            </div>
            <div class="right-body">
              <div class="right-box">
                <div class="title">落点分布</div>
                <div class="number-body">
                  <div class="number-box">
                    <div class="number-title">省级</div>
                    <div class="number-num">{{complaintData.dropDistribution.province}}</div>
                  </div>
                  <img class="right-big" src="../assets/index/ic_bm_jt.png" />
                  <div class="number-box">
                    <div class="number-title">州市</div>
                    <div class="number-num">{{complaintData.dropDistribution.city}}</div>
                  </div>
                  <img class="right-big" src="../assets/index/ic_bm_jt.png" />
                  <div class="number-box">
                    <div class="number-title">区县</div>
                    <div class="number-num">{{complaintData.dropDistribution.county}}</div>
                  </div>
                  <img class="right-big" src="../assets/index/ic_bm_jt.png" />
                  <div class="number-box">
                    <div class="number-title">企业</div>
                    <div class="number-num">{{complaintData.dropDistribution.enterprise}}</div>
                  </div>
                </div>
              </div>
              <div class="right-box">
                <div class="title">综合预警</div>
                <van-swipe :autoplay="3000" class="w-swiper" indicator-color="#BBBBBB">
                  <van-swipe-item v-for="(item,index1) in complaintData.syntheticalWarning" :key="index1">
                    <div class="item">
                      <div class="i-title">{{item.name}}</div>
                      <div class="i-cont">{{item.warning}}，{{item.description}}</div>
                      <div class="i-time">{{item.time}}</div>
                    </div>
                  </van-swipe-item>
                </van-swipe>
              </div>
              <div class="right-box">
                <div class="title">紧急程度分布</div>
                <div class="w-cont">
                  <div class="c-item" v-for="(item,index) in complaintData.emergency" :key="index">
                    <div class="i-title">{{item.name}}</div>
                    <div class="i-num" :class="[{'d-color':index==0},{'t-color':index==1},{'w-color':index==2}]">
                      {{item.value}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </van-swipe-item>
      <!-- 退货 -->
      <van-swipe-item v-if="authData.refundlimitState.refundLeader">
        <div id="main2" class="infeed-contain">
          <div class="body-contain flex-column">
            <div class="back-title">实时退货数据</div>
            <div class="change-back-contain">
              <div class="tab-box">
                <span class="t_txt" v-for="(item,index) in dataList" :key="index" :class="{'t_active':item.select}"
                  @click="selectAll(index,item)">{{item.key}}</span>
              </div>
            </div>
            <div class="white-contain" v-if="authData.refundlimitState.refundLeader">
              <div class="white-box">
                <div class="num">{{homeInfo.allReturnList}}</div>
                <div class="content">退货申请(起)</div>
                <div class="money">
                  <div class="txt">{{homeInfo.totalShoppingAmount|filt}}<i
                      v-if="parseInt(homeInfo.totalShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeInfo.totalShoppingAmount)>=10000&&parseInt(homeInfo.totalShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeInfo.totalShoppingAmount)>=100000000">亿元</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeInfo.refundSuccess}}</div>
                <div class="content">退货成功(起)</div>
                <div class="money">
                  <div class="txt">{{homeInfo.refundSuccessShoppingAmount|filt}}<i
                      v-if="parseInt(homeInfo.refundSuccessShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeInfo.refundSuccessShoppingAmount)>=10000&&parseInt(homeInfo.refundSuccessShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeInfo.refundSuccessShoppingAmount)>=100000000">亿元</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeInfo.waitHandle}}</div>
                <div class="content">处理中(起)</div>
                <div class="money">
                  <div class="txt">{{homeInfo.handlingShoppingAmount|filt}}<i
                      v-if="parseInt(homeInfo.handlingShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeInfo.handlingShoppingAmount)>=10000&&parseInt(homeInfo.handlingShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeInfo.handlingShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeInfo.waitAccept}}</div>
                <div class="content">待受理(起)</div>
                <div class="money">
                  <div class="txt">{{homeInfo.waitAcceptShoppingAmount|filt}}<i
                      v-if="parseInt(homeInfo.waitAcceptShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeInfo.waitAcceptShoppingAmount)>=10000&&parseInt(homeInfo.waitAcceptShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeInfo.waitAcceptShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeInfo.userRevoke}}</div>
                <div class="content">游客撤销(起)</div>
                <div class="money">
                  <div class="txt">{{homeInfo.userRevokeShoppingAmount|filt}}<i
                      v-if="parseInt(homeInfo.userRevokeShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeInfo.userRevokeShoppingAmount)>=10000&&parseInt(homeInfo.userRevokeShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeInfo.userRevokeShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeInfo.refuseAccept}}</div>
                <div class="content">不予受理(起)</div>
                <div class="money">
                  <div class="txt">{{homeInfo.refuseAcceptShoppingAmount|filt}}<i
                      v-if="parseInt(homeInfo.refuseAcceptShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeInfo.refuseAcceptShoppingAmount)>=10000&&parseInt(homeInfo.refuseAcceptShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeInfo.refuseAcceptShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
            </div>
            <div class="white-contain" v-if="authData.refundlimitState.refundHandler">
              <div class="white-box">
                <div class="num">{{homeWorkInfo.allReturnList}}</div>
                <div class="content">退货申请(起)</div>
                <div class="money">
                  <div class="txt">{{homeWorkInfo.totalShoppingAmount|filt}}<i
                      v-if="parseInt(homeWorkInfo.totalShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeWorkInfo.totalShoppingAmount)>=10000&&parseInt(homeInfo.totalShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeWorkInfo.totalShoppingAmount)>=100000000">亿元</i></div>
                </div>
              </div>

              <div class="white-box">
                <div class="num">{{homeWorkInfo.waitHandle}}</div>
                <div class="content">处理中(起)</div>
                <div class="money">
                  <div class="txt">{{homeWorkInfo.handlingShoppingAmount|filt}}<i
                      v-if="parseInt(homeWorkInfo.handlingShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeWorkInfo.handlingShoppingAmount)>=10000&&parseInt(homeInfo.handlingShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeWorkInfo.handlingShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeWorkInfo.refundSuccess}}</div>
                <div class="content">提款成功(起)</div>
                <div class="money">
                  <div class="txt">{{homeWorkInfo.refundSuccessShoppingAmount|filt}}<i
                      v-if="parseInt(homeWorkInfo.refundSuccessShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeWorkInfo.refundSuccessShoppingAmount)>=10000&&parseInt(homeInfo.refundSuccessShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeWorkInfo.refundSuccessShoppingAmount)>=100000000">亿元</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeWorkInfo.waitAccept}}</div>
                <div class="content">待受理(起)</div>
                <div class="money">
                  <div class="txt">{{homeWorkInfo.waitAcceptShoppingAmount|filt}}<i
                      v-if="parseInt(homeWorkInfo.waitAcceptShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeWorkInfo.waitAcceptShoppingAmount)>=10000&&parseInt(homeInfo.waitAcceptShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeWorkInfo.waitAcceptShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeWorkInfo.userRevoke}}</div>
                <div class="content">游客撤销(起)</div>
                <div class="money">
                  <div class="txt">{{homeWorkInfo.userRevokeShoppingAmount|filt}}<i
                      v-if="parseInt(homeWorkInfo.userRevokeShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeWorkInfo.userRevokeShoppingAmount)>=10000&&parseInt(homeInfo.userRevokeShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeWorkInfo.userRevokeShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
              <div class="white-box">
                <div class="num">{{homeWorkInfo.refuseAccept}}</div>
                <div class="content">不予受理(起)</div>
                <div class="money">
                  <div class="txt">{{homeWorkInfo.refuseAcceptShoppingAmount|filt}}<i
                      v-if="parseInt(homeWorkInfo.refuseAcceptShoppingAmount)<10000">元</i><i
                      v-if="parseInt(homeWorkInfo.refuseAcceptShoppingAmount)>=10000&&parseInt(homeInfo.refuseAcceptShoppingAmount)<100000000">万元</i>
                    <i v-if="parseInt(homeWorkInfo.refuseAcceptShoppingAmount)>=100000000">(亿元)</i></div>
                </div>
              </div>
            </div>
            <div class="refund-cnt">
              <div class="line-charts">近30天退货趋势</div>
              <div class="line-unit">单位（条）</div>
              <div class="line-contain">
                <lineCharts :data="returnList" :color="color" v-if="showFoundLine" />
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <!-- 诚信 -->
      <van-swipe-item
        v-if="authData.integritylimitState.integrityCityLeader || authData.integritylimitState.integrityCountyLeader || authData.integritylimitState.integrityProviLeader">
        <div id="main4" class="infeed-contain">
          <div class="body-contain sincerity flex-column">
            <div class="body-top">
              <tabinfeed ref="tabinfeed" :tabList="navList" :name="'navListTab'" @onSwitch="changeData"></tabinfeed>
            </div>
            <div class="body-cont">
              <div class="body-left flex-column">
                <div class="total-box flex-column">
                  <div class="t-title">{{grogshopTitle}}总数</div>
                  <div class="t-num">
                    {{formData.total}}
                    <span class="n-text">起</span>
                  </div>
                </div>
              </div>
              <div class="body-right flex-column">
                 <!-- 诚信指数 -->
                <div class="item-box flex-column" v-if="authData.integritylimitState.integrityCountyGeneral ||  authData.integritylimitState.integrityCountyLeader">
                  <div class="i-title">已评分企业分布</div>
                  <div class="score-box-item">
                    <div class="score-box flex-column">
                      <div class="s-title">待评数(家)<img class="img" src="../assets/image/ic_jt_ck@2x.png"></div>
                      <div class="s-num">
                        {{formData.unGraded}}

                      </div>

                    </div>
                    <div class="score-box flex-column">
                      <div class="s-title">在评数(家)<img class="img" src="../assets/image/ic_jt_ck@2x.png"></div>
                      <div class="s-num">
                        {{formData.again}}

                      </div>

                    </div>
                    <div class="score-box flex-column">
                      <div class="s-title">已评数(家)<img class="img" src="../assets/image/ic_jt_ck@2x.png"></div>
                      <div class="s-num">
                        {{formData.graded}}

                      </div>

                    </div>
                  </div>
                </div>
                <div class="item-box flex-column">
                  <div class="i-title">已评分企业分布</div>
                  <div class="score-box-item">
                    <div class="score-box flex-column">
                      <div class="s-title">评分达标</div>
                      <div class="s-num">
                        {{formData.online}}
                        <span class="n-text">起</span>
                      </div>
                      <div class="s-compare">
                        较上季度
                        <span
                          :class="['c-text', formData.pExponent==0?'':formData.pExponent>0?'up':'down']">{{formData.pExponent}}
                          {{formData.pExponent==0?'持平':formData.pExponent>0?'↑':'↓'}}</span>
                      </div>
                    </div>
                    <div class="score-box flex-column">
                      <div class="s-title">重点关注</div>
                      <div class="s-num">
                        {{formData.zExponent}}
                        <span class="n-text">家</span>
                      </div>
                      <div class="s-compare">
                        较上季度
                        <span
                          :class="['c-text', formData.zExponent==0?'':formData.zExponent>0?'up':'down']">{{formData.zExponent}}
                          {{formData.zExponent==0?'持平':formData.zExponent>0?'↑':'↓'}}</span>
                      </div>
                    </div>
                    <div class="score-box flex-column">
                      <div class="s-title">黑名单</div>
                      <div class="s-num">
                        {{formData.hExponent}}
                        <span class="n-text">家</span>
                      </div>
                      <div class="s-compare">
                        较上季度
                        <span
                          :class="['c-text', formData.hExponent==0?'':formData.hExponent>0?'up':'down']">{{formData.hExponent}}
                          {{formData.hExponent==0?'持平':formData.hExponent>0?'↑':'↓'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item-box flex-column" v-if="changeCode!='' && authData.integritylimitState.integrityProviLeader || authData.integritylimitState.integrityCityGeneral || authData.integritylimitState.integrityCityLeader">
                  <div class="i-title">{{grogshopTitle}}诚信指数</div>
                  <div class="i-tip mt8">
                    诚信指数=规范x{{integrityOption.specification}}+品质x{{integrityOption.quality}}+体验x{{integrityOption.experience}}
                  </div>
                  <div class="i-cont mt8">
                    <div class="c-left flex-column">
                      <div class="l-title">诚信指数</div>
                      <div class="l-num mt8">
                        {{scoreData}}
                        <span class="n-unit">分</span>
                      </div>
                    </div>
                    <div class=" c-right line-contain" >

                        <radarCharts :radarData="radarList1" />

                    </div>
                  </div>
                </div>
                <!-- 区县诚信指数对比 州市用户权限-->
                <template v-if="changeCode!=''">
                  <div class="item-box flex-column"
                    v-if="authData.integritylimitState.integrityCityGeneral || authData.integritylimitState.integrityCityLeader">
                    <div class="i-title">区县诚信指数对比</div>
                    <div class="i-cont mt8 map line-contain">
                      <axisRankCharts :rankList="countyCompareData" />
                    </div>
                  </div>
                </template>
                <!-- 州市诚信指数对比 省用户权限-->
                <template v-if="changeCode!=''">
                  <div class="item-box flex-column" v-if="authData.integritylimitState.integrityProviLeader">
                    <div class="i-title">州市诚信指数对比</div>
                    <div class="i-cont mt8 map line-contain">
                      <MapChartsIntegrity :list="mapData" :level="level" />
                    </div>
                  </div>
                </template>
                <!-- 州市诚信指数排行 -->
                <!-- <div class="item-box flex-column">
            <div class="i-cont mt8 map">
              <sortRankCharts :rankList="rankList" :name="'州市诚信指数排行'" />
            </div>
          </div>-->
                <!-- 区县诚信指数排行 -->
                <!-- <div class="item-box flex-column">
            <div class="i-cont mt8 map">
              <sortRankCharts :rankList="rankList" :name="'区县诚信指数排行'" />
            </div>
          </div>-->
                <!-- 诚信指数得分分布 -->
                <div class="item-box flex-column">
                  <div class="i-title">诚信指数得分分布</div>
                  <div class="i-cont mt8 map line-contain"  >
                    <pieChartsInfeedLong :pieData="pieInfeedList" v-if="showIntePie" />
                  </div>
                </div>
                <!-- 细分指数得分分布 -->
                <div class="item-box flex-column">
                  <div class="i-title">细分指数得分分布</div>
                  <div class="i-cont mt8 map justify-center ">
                    <columnChartsInfeed :experience="experience" :quality="quality" :standard="standard" />
                  </div>
                </div>
                <!-- 企业排行榜 州市用户权限 -->
                <template v-if="changeCode!=''">
                  <div class="item-box flex-column"
                    v-if="authData.integritylimitState.integrityCityGeneral ||  authData.integritylimitState.integrityCityLeader || authData.integritylimitState.integrityCountyGeneral ||  authData.integritylimitState.integrityCountyLeader">
                    <div class="i-cont mt8 map">
                      <sortRankCharts :rankList="EnterpriseRankingData" :name="'企业排行榜'" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <!-- 导游 -->
      <van-swipe-item v-if="guidePower.guideHandler || guidePower.guideLeader">
        <div id="main5" class="infeed-contain">
          <!-- 导游 省级 -->
          <div class="body-contain guide" v-if="guidePower.guideLeader">
            <div class="body-left flex-column">
              <!-- 州市级加class mt40 省级去掉-->
              <div class="score-box flex-column">
                <div class="s-num">
                  {{guideData.dashboard.numbers}}
                  <span class="n-text">名</span>
                </div>
                <div class="s-compare">
                  较上季度
                  <span class="c-text" v-if="guideData.dashboard.compare === 'equal'">持平</span>
                  <span class="c-text up"
                    v-if="guideData.dashboard.compare === 'add'">+{{guideData.dashboard.price}}↑</span>
                  <span class="c-text down"
                    v-if="guideData.dashboard.compare === 'decrease'">-{{guideData.dashboard.price}}↓</span>
                </div>
              </div>
            </div>
            <div class="body-right flex-column">
              <div class="tab-box">
                <!-- 省级权限显示前两个，市级权限显示后两个 -->
                <tab :tabList="['州市数量分布','数量变化趋势']" :name="'sincerityTab'" @onSwitch="myGuidePendingSincerity"></tab>
              </div>
              <!-- 州市数量分布 -->
              <div class="r-cont" v-if="guideTabIndex === 0">
                <div class="c-left">
                  <mapCharts :list="guideData.mapList" :level="guidelevel" v-if="guideTabIndex === 0" />
                </div>
                <div class="c-right line-contain">
                  <grayRankCharts :rankList="guideData.rankList" :unit="'名'" />
                </div>
              </div>
              <!-- 数量变化趋势 -->
              <div class="r-cont" v-if="guideTabIndex === 1">
                <guideLineCharts :interval="1" :showYear="true" :unit="'名'"
                    :showNum="true" :data="guideData.trendList" :color="color" />
              </div>
            </div>
          </div>
          <!-- 导游 市级 -->
          <div class="body-contain guide" v-if="guidePower.guideHandler">
            <div class="body-left flex-column">
              <div class="score-box flex-column mt40">
                <div class="s-num">
                  {{guideData.dashboard.numbers}}
                  <span class="n-text">起</span>
                </div>
                <div class="s-compare">
                  较上季度
                  <span class="c-text" v-if="guideData.dashboard.compare === 'equal'">持平</span>
                  <span class="c-text up"
                    v-if="guideData.dashboard.compare === 'add'">+{{guideData.dashboard.price}}↑</span>
                  <span class="c-text down"
                    v-if="guideData.dashboard.compare === 'decrease'">{{guideData.dashboard.price}}↓</span>
                </div>
                <div class="score mt40">
                  <p class="small">第</p>
                  <p class="nomal">{{guideData.rank.numbers}}</p>
                  <p class="small">名</p>
                </div>
                <div class="s-compare">
                  较上季度
                  <span class="c-text" v-if="guideData.rank.compare === 'equal'">持平</span>
                  <span class="c-text up" v-if="guideData.rank.compare === 'add'">+{{guideData.rank.price}}↑</span>
                  <span class="c-text down"
                    v-if="guideData.rank.compare === 'decrease'">-{{guideData.rank.price}}↓</span>
                </div>
              </div>
              <!-- 州市级显示，省级不显示-->
            </div>
            <div class="body-right flex-column">
              <div class="tab-box">
                <!-- 省级权限显示前两个，市级权限显示后两个 -->
                <tab :tabList="['数量变化趋势','州市排名']" :name="'sincerityTab'" @onSwitch="myGuidePendingSincerity"></tab>
              </div>
              <!-- 数量变化趋势 -->
              <div class="r-cont" v-if="guideTabIndex === 0">
                <guideLineCharts :interval="1" :showYear="true" :unit="'名'"
                    :showNum="true"  :data="guideData.trendList" :color="color" />
              </div>
              <!-- 州市排名 -->
              <div class="r-cont mt12" v-if="guideTabIndex === 1">
                <!--
              @props firstSize  第一页显示多少条数据，list长度超出则显示 查看更多
                     selfId     州市权限时的当前州市id，该州市排名则在第一条展示
          -->
                <guideRankCharts :rankList="guideData.rankList" :firstSize="20" :selfId="Number(guidePower.city)" />
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <!-- 旅行社 -->
      <van-swipe-item v-if="travelPower.travelAgencyLeader || travelPower.travelAgencyHandler">
        <div id="main6" class="infeed-contain">
          <!-- 旅行社 省级 -->
          <div class="body-contain guide" v-if="travelPower.travelAgencyLeader">
            <div class="body-left flex-column">
              <!-- 州市级加class mt40 省级去掉-->
              <div class="score-box flex-column">
                <div class="s-num">
                  {{travelData.dashboard.numbers}}
                  <span class="n-text">家</span>
                </div>
                <div class="s-compare">
                  较上季度
                  <span class="c-text" v-if="travelData.dashboard.compare === 'equal'">持平</span>
                  <span class="c-text up"
                    v-if="travelData.dashboard.compare === 'add'">+{{travelData.dashboard.price}}↑</span>
                  <span class="c-text down"
                    v-if="travelData.dashboard.compare === 'decrease'">-{{travelData.dashboard.price}}↓</span>
                </div>
              </div>
            </div>
            <div class="body-right flex-column">
              <div class="tab-box">
                <!-- 省级权限显示前两个，市级权限显示后两个 -->
                <tab :tabList="['州市数量分布','数量变化趋势']" :name="'sincerityTab'" @onSwitch="myTravelPendingSincerity"></tab>
              </div>
              <!-- 州市数量分布 -->
              <div class="r-cont" v-if="travelTabIndex === 0">
                <div class="c-left">
                  <mapCharts :list="travelData.mapList" :level="travellevel" v-if="travelTabIndex === 0" />
                </div>
                <div class="c-right line-contain">
                  <grayRankCharts :rankList="travelData.rankList" :unit="'名'" />
                </div>
              </div>
              <!-- 数量变化趋势 -->
              <div class="r-cont" v-if="travelTabIndex === 1">
                <lineCharts :data="travelData.trendList" :color="color" />
              </div>
            </div>
          </div>
          <!-- 旅行社 市级 -->
          <div class="body-contain guide" v-if="travelPower.travelAgencyHandler">
            <div class="body-left flex-column">
              <div class="score-box flex-column mt40">
                <div class="s-num">
                  {{travelData.dashboard.numbers}}
                  <span class="n-text">起</span>
                </div>
                <div class="s-compare">
                  较上季度
                  <span class="c-text" v-if="travelData.dashboard.compare === 'equal'">持平</span>
                  <span class="c-text up"
                    v-if="travelData.dashboard.compare === 'add'">+{{travelData.dashboard.price}}↑</span>
                  <span class="c-text down"
                    v-if="travelData.dashboard.compare === 'decrease'">-{{travelData.dashboard.price}}↓</span>
                </div>
                <div class="score mt40">
                  <p class="small">第</p>
                  <p class="nomal">{{travelData.rank.numbers}}</p>
                  <p class="small">名</p>
                </div>
                <div class="s-compare">
                  较上季度
                  <span class="c-text" v-if="travelData.rank.compare === 'equal'">持平</span>
                  <span class="c-text up" v-if="travelData.rank.compare === 'add'">+{{travelData.rank.price}}↑</span>
                  <span class="c-text down"
                    v-if="travelData.rank.compare === 'decrease'">-{{travelData.rank.price}}↓</span>
                </div>
              </div>
              <!-- 州市级显示，省级不显示-->
              <!-- <div class="score-box flex-column mt40">

        </div>-->
            </div>
            <div class="body-right flex-column">
              <div class="tab-box">
                <!-- 省级权限显示前两个，市级权限显示后两个 -->
                <tab :tabList="['数量变化趋势','州市排名']" :name="'sincerityTab'" @onSwitch="myTravelPendingSincerity"></tab>
              </div>
              <!-- 数量变化趋势 -->
              <div class="r-cont" v-if="travelTabIndex === 0">
                <lineCharts :data="travelData.trendList" :color="color" />
              </div>
              <!-- 州市排名 -->
              <div class="r-cont mt12" v-if="travelTabIndex === 1">
                <!--
              @props firstSize  第一页显示多少条数据，list长度超出则显示 查看更多
                     selfId     州市权限时的当前州市id，该州市排名则在第一条展示
          -->
                <guideRankCharts :rankList="travelData.rankList" :firstSize="20" :selfId="Number(guidePower.city)" />
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <!-- 考核 -->
      <van-swipe-item v-if="accessState.assessProviLeader || accessState.assessStateCityLeader">
        <div id="main3" class="infeed-contain">
          <div class="body-contain" v-if="assesspower === 2">
            <div class="left-text-body">
              <div class="srore-box">
                <div class="title">{{assessment.title}}</div>
                <div class="score">
                  <p class="nomal">{{assessment.num}}</p>
                </div>
                <div class="up-down">
                  <p class="nomal">较上季度</p>
                  <p class="red">{{assessment.diff}}</p>
                </div>
              </div>
              <div class="srore-box">
                <div class="title">{{ranking.title}}</div>
                <div class="score">
                  <p class="small">第</p>
                  <p class="nomal">{{ranking.num}}</p>
                  <p class="small">名</p>
                </div>
                <div class="up-down">
                  <p class="nomal">较上季度</p>
                  <p class="green">{{ranking.diff}}</p>
                  <img class="top" src="../assets/image/rise.png" />
                </div>
              </div>
            </div>
            <div class="right-text-body">
              <evolve :listData="detailList" :isOpen="isOpen"></evolve>
            </div>
          </div>
          <div class="body-contain" v-if="assesspower === 1">
            <div class="power1box">
              <div class="title-box">
                <div class="title">一类地区</div>
                <div class="title-border"></div>
              </div>
              <div class="rank-box">
                <rankCharts :rankList="rankList1" />
              </div>
            </div>
            <div class="power1box power-right">
              <div class="title-box">
                <div class="title">二类地区</div>
                <div class="title-border"></div>
              </div>
              <div class="rank-box">
                <rankCharts :rankList="rankList2" />
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="change-box">
      <img class="left-change" :class="curIndex==0?'opacity02':'opacity1'" src="../assets/index/ic_left_arrow.png"
        @click="handleLeft" />
      <div class="border"></div>
      <img class="right-change" :class="curIndex==swipeTitle.length-1 ?'opacity02':'opacity1'"
        src="../assets/index/ic_right_arrow.png" @click="handleRight" />
    </div>
  </div>
</template>
<script>
    import util from '@/utils/common';
    import moment from 'moment';
    import guideRankCharts from '../pages/guideSystem/components/guideRankCharts';
    import pieChartsInfeedLong from '../components/PieChartsInfeedLong';
    import columnChartsInfeed from '../pages/index/components/SinceritySubdivisionBar';
    import tab from 'comps/tab';
    import tabinfeed from 'comps/tabinfeed';
    import grayRankCharts from 'comps/grayRankCharts';
    import mapCharts from '../components/MapCharts';
    import MapChartsIntegrity from '../components/MapChartsIntegrity';
    import axisRankCharts from '../components/axisRankCharts';
    import radarCharts from '../components/RadarCharts';
    import evolve from '../pages/appraise/components/evolve';
    import lineCharts from '../components/LineCharts';
    import guideLineCharts from '../pages/guideSystem/components/LineCharts';
    import rankCharts from '../pages/index/components/indexRankChartsInfeed';
    import sortRankCharts from '../components/sortRankCharts';
    import api from 'apis';
    import refundworkapi from '../service/modules/refund';
    import apis from '../service/modules/index';
    export default {
        filters: {
            filt (value) {
                if (parseInt(value) < 10000) {
                    return value
                } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
                    return (parseFloat((value) / 10000).toFixed(2))
                } else if (parseInt(value) >= 100000000) {
                    return (parseFloat((value) / 100000000).toFixed(2))
                }
            }
        },
        components: {
            guideRankCharts,
            pieChartsInfeedLong,
            columnChartsInfeed,
            evolve,
            tab,
            grayRankCharts,
            mapCharts,
            MapChartsIntegrity,
            axisRankCharts,
            sortRankCharts,
            radarCharts,
            rankCharts,
            guideLineCharts,
            lineCharts,
            tabinfeed
        },
        props: {},
        data () {
            return {
                pageTitle: '',
                swipeTitle: [],
                navTitle: '',
                type: -1,
                assesspower: 1,
                isOpen: false,
                maxLength: 157,
                unit: '起',
                maxValue: 77226,
                detailList: [],
                // 退货tab切换
                dataList: [{
                               key: '今日',
                               select: true,
                               value: 'today'
                           },
                           {
                               key: '本周',
                               select: false,
                               value: 'week'
                           },
                           {
                               key: '本月',
                               select: false,
                               value: 'mouth'
                           },
                           {
                               key: '全部',
                               select: false,
                               value: 'all'
                           }
                ],
                // 退货折线图
                lineList: [{
                               xAxis: '1',
                               num: '290'
                           },
                           {
                               xAxis: '2',
                               num: '330'
                           },
                           {
                               xAxis: '3',
                               num: '100'
                           },
                           {
                               xAxis: '4',
                               num: '220'
                           },
                           {
                               xAxis: '5',
                               num: '150'
                           },
                           {
                               xAxis: '6',
                               num: '300'
                           },
                           {
                               xAxis: '7',
                               num: '420'
                           },
                           {
                               xAxis: '8',
                               num: '180'
                           },
                           {
                               xAxis: '9',
                               num: '290'
                           },
                           {
                               xAxis: '10',
                               num: '120'
                           },
                           {
                               xAxis: '11',
                               num: '290'
                           },
                           {
                               xAxis: '12',
                               num: '330'
                           },
                           {
                               xAxis: '13',
                               num: '100'
                           },
                           {
                               xAxis: '14',
                               num: '220'
                           },
                           {
                               xAxis: '15',
                               num: '150'
                           },
                           {
                               xAxis: '16',
                               num: '300'
                           },
                           {
                               xAxis: '17',
                               num: '420'
                           },
                           {
                               xAxis: '18',
                               num: '180'
                           },
                           {
                               xAxis: '19',
                               num: '290'
                           },
                           {
                               xAxis: '20',
                               num: '120'
                           }
                ],
                color: 'green',
                sincerityTab: ['全部', '酒店', '旅行社', '租赁车', '旅游汽车', '餐饮'],
                // 雷达图
                radarList1: [{
                                 name: '品质指数',
                                 max: 10,
                                 value: 7.6
                             },
                             {
                                 name: '体验指数',
                                 max: 10,
                                 value: 8.2
                             },
                             {
                                 name: '规范指数',
                                 max: 10,
                                 value: 10
                             }
                ],
                // 地图数据
                list: [{
                           name: '昆明市',
                           value: 30
                       },
                       {
                           name: '曲靖市',
                           value: 10
                       },
                       {
                           name: '玉溪市',
                           value: 2
                       },
                       {
                           name: '保山市',
                           value: 20
                       },
                       {
                           name: '昭通市',
                           value: 30
                       },
                       {
                           name: '丽江市',
                           value: 40
                       },
                       {
                           name: '普洱市',
                           value: 60
                       },
                       {
                           name: '临沧市',
                           value: 20
                       },
                       {
                           name: '楚雄彝族自治州',
                           value: 30
                       },
                       {
                           name: '红河哈尼族彝族自治州',
                           value: 30
                       },
                       {
                           name: '文山壮族苗族自治州',
                           value: 50
                       },
                       {
                           name: '西双版纳傣族自治州',
                           value: 70
                       },
                       {
                           name: '大理白族自治州',
                           value: 6
                       },
                       {
                           name: '德宏傣族景颇族自治州',
                           value: 6
                       },
                       {
                           name: '怒江傈僳族自治州',
                           value: 6
                       },
                       {
                           name: '迪庆藏族自治州',
                           value: 2
                       }
                ],
                level: [{
                            min: 51,
                            color: 'rgba(54,179,116,1)'
                        },
                        {
                            min: 11,
                            max: 50,
                            color: 'rgba(54,179,116,0.7)'
                        },
                        {
                            min: 6,
                            max: 10,
                            color: 'rgba(54,179,116,0.4)'
                        },
                        {
                            min: 0,
                            max: 5,
                            color: 'rgba(54,179,116,0.1)'
                        }
                ],
                travellevel: [
                    { 'min': 100, 'color': 'rgba(54,179,116,1)' },
                    { 'min': 20, 'max': 99, 'color': 'rgba(54,179,116,0.7)' },
                    { 'min': 10, 'max': 19, 'color': 'rgba(54,179,116,0.4)' },
                    { 'min': 1, 'max': 9, 'color': 'rgba(54,179,116,0.1)' }
                ],
                guidelevel: [
                    { 'min': 1000, 'color': 'rgba(54,179,116,1)' },
                    { 'min': 100, 'max': 999, 'color': 'rgba(54,179,116,0.7)' },
                    { 'min': 10, 'max': 99, 'color': 'rgba(54,179,116,0.4)' },
                    { 'min': 1, 'max': 9, 'color': 'rgba(54,179,116,0.1)' }
                ],
                rankList: [{
                               id: 1,
                               city: '昆明市',
                               mark: '90.00',
                               change: 1,
                               changeRank: 2
                           },
                           {
                               id: 2,
                               city: '西双版纳州',
                               mark: '80.00',
                               change: 2,
                               changeRank: 2
                           },
                           {
                               id: 3,
                               city: '昆明市',
                               mark: '72.30',
                               change: 1,
                               changeRank: 2
                           },
                           {
                               id: 4,
                               city: '昆明市',
                               mark: '60.00',
                               change: 2,
                               changeRank: 2
                           },
                           {
                               id: 5,
                               city: '昆明市',
                               mark: '50.00',
                               change: 0,
                               changeRank: 2
                           },
                           {
                               id: 6,
                               city: '昆明市',
                               mark: '30.00',
                               change: 1,
                               changeRank: 2
                           }
                ],
                // 导旅排行数据
                guideRankCharts: [{
                                      id: 1,
                                      city_id: 381,
                                      cityShortName: '昆明市',
                                      count: '90.00',
                                      change: 1,
                                      changeRank: 2
                                  },
                                  {
                                      id: 2,
                                      city_id: 382,
                                      cityShortName: '西双版纳州',
                                      count: '80.00',
                                      change: 2,
                                      changeRank: 2
                                  },
                                  {
                                      id: 3,
                                      city_id: 383,
                                      cityShortName: '昆明市',
                                      count: '72.30',
                                      change: 1,
                                      changeRank: 2
                                  },
                                  {
                                      id: 4,
                                      city_id: 384,
                                      cityShortName: '昆明市',
                                      count: '60.00',
                                      change: 2,
                                      changeRank: 2
                                  },
                                  {
                                      id: 5,
                                      city_id: 385,
                                      cityShortName: '昆明市',
                                      count: '50.00',
                                      change: 0,
                                      changeRank: 2
                                  },
                                  {
                                      id: 6,
                                      city_id: 386,
                                      cityShortName: '昆明市',
                                      count: '30.00',
                                      change: 1,
                                      changeRank: 2
                                  }
                ],
                // 全屏饼图
                pieInfeedList: [],
                showIntePie: false,
                // 横屏柱状图
                experienceList: [10, 52, 200, 334, 390, 330, 220, 120, 190, 250],
                qualityList: [100, 52, 100, 334, 390, 130, 220, 120, 290, 150],
                standardList: [200, 52, 200, 234, 290, 130, 320, 220, 190, 250],
                guideTabIndex: 3,
                travelTabIndex: 3,

                // start 导游 by huhui
                guideData: {},
                guidePower: {},
                // end 导游 by huhui

                /// /////////////////////投诉
                complaintData: {},
                /// /////////////////////投诉

                /// /////////////////////退货
                startTime: moment(new Date().getTime()).format('YYYY-MM-DD'),
                endTime: moment(new Date().getTime()).format('YYYY-MM-DD'),
                homeInfo: '',
                citycode: '530000',
                checked: true,
                returnList: [],
                homeWorkInfo: '',
                /// /////////////////////退货
                /// /////////////////////旅行社
                travelData: [],
                travelPower: {},
                /// /////////////////////旅行社
                /// /////////////////////考核
                rankList1: [],
                rankList2: [],
                assessment: '',
                ranking: '',
                accessState: '',
                /// /////////////////////考核

                /// /////////////////////诚信
                formData: [],
                navList: [],
                changeCode: '',

                grogshopTitle: '',
                isShowTab: 0,
                EnterpriseRankingFlag: false, // 企业排行榜正序倒叙
                EnterpriseRankingData: '',
                countyCompareData: '',
                // 诚信指数
                integrityOption: {
                    experience: 0, // 规范
                    quality: 0, // 品质
                    specification: 0 // 体验
                },
                // 诚信指数分数
                scoreData: '',
                experience: [], // 体验指数
                quality: [], // 品质指数
                // 地图
                mapData: [],
                mapList: [],
                standard: [], // 规范指数
                /// /////////////////////诚信

                curIndex: 0,
                lengthCard: 5,
                showFoundLine: false
            };
        },
        computed: {},
        watch: {

        },
        methods: {
            onChange (index) {
                this.pageTitle = this.swipeTitle[index].name
            },
            handleLeft () {
                if (this.curIndex > 0) {
                    this.curIndex--
                    this.$refs.vanswipe.swipeTo(this.curIndex)
                }
            },
            handleRight () {
                if (this.swipeTitle.length - 1 > this.curIndex) {
                    this.$refs.vanswipe.swipeTo(++this.curIndex)
                }
            },
            swipeTo (index) {
                this.curIndex = index
                this.pageTitle = this.swipeTitle[index].name
                this.$nextTick(() => {
                    this.$refs.vanswipe.swipeTo(index)
                })
            },

            close () {
                // this.type = -1;
                // this.$emit('onBack');
                window.yyn.invokeJSB('transformScreen', {
                    landscape: 0, // 是否横屏 1 横屏  0 竖屏
                    url: '' // 页面请求H5地址

                }, () => {

                })
            },
            more () {
                window.yyn.invokeJSB('transformScreen', {
                    landscape: 0, // 是否横屏 1 横屏  0 竖屏
                    url: `${this.globalApp.getSystemInfo().host}/web/#` + this.swipeTitle[this.curIndex].path
                }, () => {
                })
                // this.$router.push(this.swipeTitle[this.curIndex].path)
            },
            open (type, title) {
                this.type = type;
                this.navTitle = title;
            },

            // /////////////////////////////////////////////
            // start 导游 by huhui
            // /////////////////////////////////////////////
            loadGuideData (data, power) {
                this.guideData = data;
                this.guidePower = power;
                console.log('this.guideData:', this.guideData);
                console.log('this.guidePower:', this.guidePower);
                setTimeout(() => {
                    this.guideTabIndex = 0
                }, 50);
            },

            // /////////////////////////////////////////////
            // end 导游 by huhui
            // /////////////////////////////////////////////

            // /////////////////////////////////////////////
            // start 旅行社
            // /////////////////////////////////////////////
            loadTravelData (data, power) {
                this.travelData = data;
                this.travelPower = power;
                setTimeout(() => {
                    this.travelTabIndex = 0
                }, 50);
            },

            // /////////////////////////////////////////////
            // end 旅行社
            // /////////////////////////////////////////////

            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 投诉↓↓↓
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            getComplaintData (data) {
                this.complaintData = data;
            },
            goRoute (value) {
                this.$router.push({
                    path: '/complaint/leaderListSec',
                    query: {
                        typeSign: 'dropDistribution',
                        dafaultType: value,
                        areaOne: this.areaOne
                    }
                });
            },
            leaderList (item, areaOne) {
                this.$router.push({
                    path: '/complaint/leaderListFirst',
                    query: {
                        type: item,
                        areaOne: areaOne
                    }
                });
            },
            toLeaderWarningList (type, value, areaOne) {
                // 底部紧急程度模块
                // 还需要传当前区域id
                // console.log(type, value);
                this.$router.push({
                    path: '/complaint/earlyWarning',
                    query: {
                        typeSign: type,
                        dafaultType: value,
                        areaOne: areaOne
                    }
                });
            },
            goList (type, value, area) {
                // 轮播图跳转的页面
                // console.log(type, value);
                // 还需要传当前区域id
                this.$router.push({
                    path: '/complaint/comprehensiveWarningList',
                    query: {
                        type: type,
                        warningType: value,
                        place: area
                    }
                });
            },
            Workbench (type, area) { // 处理工作台
                this.$store.commit('complaint/setHandleWorkbench', true);
                let routeType = '';
                if (type === 'notResponse') { // 待响应
                    this.newType = 'centerNotAcceptList';
                } else if (type === 'notHandle') { // 待处理
                    if (this.unitType === 'dep') {
                        this.newType = 'waitDispose';
                        routeType = 1;
                    } else {
                        this.newType = 'centerNotHandleList';
                        routeType = '';
                    }
                } else if (type === 'reportVerify') { // 上报待审核
                    this.newType = 'reportCheck';
                } else if (type === 'superviseNotAccept') { // 待受理督办件
                    this.newType = 'superviseNotAccept';
                } else if (type === 'appealApplyVerify') { // 拆单待审核
                    if (this.unitType === 'dep') {
                        this.newType = 'additionalComplainDisposeCheck';
                        routeType = 1;
                    } else {
                        this.newType = 'applySplitVerify';
                        routeType = '';
                    }
                }
                console.log('type', this.newType)
                if (this.unitType === 'dep' && routeType === 1) {
                    this.$router.push({
                        path: '/complaint/workerListForth',
                        query: {
                            type: this.newType,
                            areaOne: area,
                            fullAdress: this.fullAdress
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/complaint/workerListFirst',
                        query: {
                            type: this.newType,
                            areaOne: area,
                            fullAdress: this.fullAdress
                        }
                    })
                }
            },

            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 投诉↑↑↑
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////

            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 退货↓↓↓
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            selectAll (index, item) {
                this.dataList.map((item, index1) => {
                    this.$set(this.dataList[index1], 'select', false);
                });
                this.$set(this.dataList[index], 'select', true);
                this.aboutTime = item.value;
                if (item.value === 'today') {
                    this.startTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                } else if (item.value === 'week') {
                    let nowTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    var data = util.getWeekStartEnd(moment, nowTime);
                    this.startTime = data.start;
                    this.endTime = data.end;
                } else if (item.value === 'mouth') {
                    var currentDateMon = new Date();
                    // 获取当前月的第一天
                    this.startTime = this.getCurrentMonthFirst(currentDateMon);
                    // 获取当前月的最后一天
                    this.endTime = this.getCurrentMonthLast(currentDateMon);
                } else if (item.value === 'all') {
                    this.startTime = '2019-05-01';
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                }
                // this.$store.state.startTime = this.startTime
                // this.$store.state.endTime = this.endTime
                if (this.authData.refundlimitState.refundLeader) {
                    this.getInfoList();
                }
                if (this.authData.refundlimitState.refundHandler) {
                    this.getWorkInfoList();
                }
                this.getInitTime(this.startTime, this.endTime);
            },
            getInitTime (startTime, endTime) {
                // 获取初始化时间
                this.$store.commit('refund/getStartTime', startTime);
                this.$store.commit('refund/getEndTime', endTime);
            },
            getCurrentMonthFirst (d) {
                var date = new Date(d);
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getCurrentMonthLast (d) {
                var date = new Date(d);
                var currentMonth = date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                var oneDay = 1000 * 60 * 60 * 24;
                var lastTime = new Date(nextMonthFirstDay - oneDay);
                var month = parseInt(lastTime.getMonth() + 1);
                var day = lastTime.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getInfoList () {
                refundworkapi.workbenchLeader({
                    areaId: this.citycode,
                    startDate: this.startTime,
                    endDate: this.endTime
                }).then(res => {
                    if (res.ret === 0) {
                        this.homeInfo = res.data;
                    }
                });
            },
            getWorkInfoList () {
                refundworkapi.workbench({
                    areaId: this.citycode,
                    startDate: this.startTime,
                    endDate: this.endTime
                }).then(res => {
                    if (res.ret === 0) {
                        this.homeWorkInfo = res.data;
                    }
                });
            },
            getTrend (dataList) {
                api.lately30Trendhome().then(res => {
                    if (res.ret === 0) {
                        this.returnList = [];
                        const arr = [];
                        res.data.map((item, index) => {
                            var obj = {
                                xAxis: item.date.substring(5, 10),
                                num: item.count
                            };

                            arr.push(obj);
                        });
                        this.returnList = arr;
                        console.log('ressssssssssssssssssssssssssssssssssss:', this.returnList)
                        setTimeout(() => {
                            this.showFoundLine = true
                        }, 50);
                    }
                });
            },
            getRefundData () {
                this.getInitTime(this.startTime, this.endTime);
                if (this.authData.refundlimitState.refundLeader) {
                    refundworkapi.currentUser().then(res => {
                        if (res.ret === 0) {
                            this.$store.commit('refund/getUserInfo', res.data);

                            this.citycode = res.data.regionCode;
                            this.getInfoList();
                        }
                    })
                }
                if (this.authData.refundlimitState.refundHandler) {
                    this.getWorkInfoList();
                }
                this.getTrend()
            },
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 退货↑↑↑
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////

            resizeWindow (tag) {
                var width = document.documentElement.clientWidth;
                var height = document.documentElement.clientHeight;
                var wrapper = document.getElementById(tag);

                var style = '';
                if (width >= height) {
                    // 竖屏
                    style += 'width:100%';
                    style += 'height:100%;';
                    style += '-webkit-transform: rotate(0); transform: rotate(0);';
                    style += '-webkit-transform-origin: 0 0;';
                    style += 'transform-origin: 0 0;';
                } else {
                    // 横屏
                    style += 'width:' + height + 'px;'; // 注意旋转后的宽高切换
                    style += 'height:' + width + 'px;';
                    style += '-webkit-transform: rotate(90deg); transform: rotate(90deg);';
                    // 注意旋转中点的处理
                    style +=
                        '-webkit-transform-origin: ' + width / 2 + 'px ' + width / 2 + 'px;';
                    style += 'transform-origin: ' + width / 2 + 'px ' + width / 2 + 'px;';
                }
                wrapper.style.cssText = style;
                console.log('wrapper.style.cssText:', wrapper.style.cssText);
            },

            on_resizeWindow () {
                var height = document.documentElement.clientHeight;
                var sh = height - document.getElementById('top-contain').offsetHeight;

                var wrapper = document.getElementById('infeed-swipe')

                wrapper.style.cssText = 'height:' + sh + 'px;';
            },

            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 诚信↓↓↓
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////

            changeData (item, index) {
                this.changeCode = item.code;
                this.grogshopTitle = item.name;

                this.getstatisticsTotal();
                this.getEnterpriseRanking(); // 企业排行榜
                this.getproviceListData(); // 州市诚信排行榜
                // this.getAreaListData(); // 区县诚信排行榜
                this.getDistribution(); // 诚信指数
                this.getCountyCompare(); // 区县诚信指数对比
                this.getexponentDistribution(); // 细分指数得分分部
                this.getAverage(); // 行业平均得分
            },
            getIntegrityData () {
                this.getindustryCategory();
                this.getstatisticsTotal();
                this.getDistribution(); // 诚信指数
                // this.getAverage()
                // this.getEnterpriseRanking(); // 企业排行榜
                // this.getproviceListData(); // 州市诚信排行榜
                // this.getAreaListData(); // 区县诚信排行榜
                // this.getCountyCompare(); // 区县诚信指数对比
                this.getexponentDistribution(); // 细分指数得分分部
            },
            // 区县诚信排行榜
            getAreaListData () {
                let parm = {
                    regionCode: this.cityCode,
                    industryCategory: this.changeCode
                };
                api.countyRanking(parm).then(res => {
                    this.areaListData = res.data.list;
                });
            },
            // 州市诚信排行榜
            getproviceListData () {
                let parm = {
                    regionCode: this.authData.integritylimitState.regionCode || '530000',
                    industryCategory: this.changeCode
                };
                api.citRanking(parm).then(res => {
                    if (res.ret === 0) {
                        this.proviceListData = res.data.list;
                        let data = res.data;
                        let arrList = JSON.parse(
                            JSON.stringify(data.list)
                                .replace(/regionName/g, 'name')
                                .replace(/score/g, 'value')
                        );
                        let dataLength = this.mapList.length; // 初始数据
                        let arrListLength = arrList.length; // 接口数据
                        for (let i = 0; i < dataLength; i++) {
                            for (let j = 0; j < arrListLength; j++) {
                                if (arrListLength > 0) {
                                    if (this.mapList[i]['name'] === arrList[j]['name']) {
                                        this.mapList.splice(i, 1);
                                        dataLength--;
                                    }
                                }
                            }
                        }
                        this.mapData = [...this.mapList, ...arrList];

                        console.log(this.mapData, '==========')
                    }
                });
            },
            // 细分指数得分分部
            getexponentDistribution () {
                let parm = {
                    regionCode: this.authData.integritylimitState.regionCode || '530000',
                    industryCategory: this.changeCode
                };
                api.exponentDistribution(parm).then(res => {
                    this.experience = res.data.experience;
                    this.quality = res.data.quality;
                    this.standard = res.data.standard;
                });
            },
            // 行业平均得分
            getAverage () {
                let parm = {
                    regionCode: this.authData.integritylimitState.regionCode || '530000',
                    industryCategory: this.changeCode // 行业类别
                };
                api.average(parm).then(res => {
                    if (res.ret === 0) {
                        try {
                            let data = res.data;
                            this.integrityOption.experience = data.weightConfig.experience / 100;
                            this.integrityOption.quality = data.weightConfig.quality / 100;
                            this.integrityOption.specification =
                                data.weightConfig.specification / 100;

                            this.scoreData = (
                                (data.weightConfig.experience / 100) * data.experienceScore +
                                (data.weightConfig.quality / 100) * data.qualityScore +
                                (data.weightConfig.specification / 100) * data.standardScore
                            ).toFixed(1);
                            this.radarList1 = [{
                                                   name: '品质指数',
                                                   max: 10,
                                                   value: data.qualityScore.toFixed(1)
                                               },
                                               {
                                                   name: '体验指数',
                                                   max: 10,
                                                   value: data.standardScore.toFixed(1)
                                               },
                                               {
                                                   name: '规范指数',
                                                   max: 10,
                                                   value: data.experienceScore.toFixed(1)
                                               }
                            ];
                        } catch (error) {
                            console.log('转换错误', 'row 734')
                        }
                    }
                });
            },
            // 企业排行榜
            getEnterpriseRanking () {
                let parm = {
                    pageIndex: 1,
                    pageSize: 5,
                    regionCode: this.authData.integritylimitState.regionCode || '530000',
                    industryCategory: this.changeCode,
                    asc: this.EnterpriseRankingFlag
                };
                api.enterpriseRanking(parm).then(res => {
                    if (res.ret === 0) {
                        this.EnterpriseRankingData = res.data.list;
                    }
                });
            },
            // 区县诚信指数对比
            getCountyCompare () {
                let parm = {
                    regionCode: '',
                    industryCategory: this.changeCode
                };
                api.countyCompare(parm).then(res => {
                    if (res.ret === 0) {
                        for (let i in res.data) {
                            res.data[i].city = res.data[i].regionName;
                            res.data[i].mark = res.data[i].score;
                        }
                        this.countyCompareData = res.data;
                    }
                });
            },
            // 获取基础数据
            getstatisticsTotal () {
                let parm = {
                    regionCode: this.authData.integritylimitState.regionCode || '530000', // 区域code
                    industryCategory: this.changeCode // 行业code
                };
                api.statisticsTotal(parm).then(res => {
                    // console.log(123, res)
                    if (res.ret === 0) {
                        let data = res.data;
                        this.total = 1 * data.unGraded + 1 * data.again + 1 * data.graded;
                        data.total = this.total;
                        data.pExponent = data.online - data.lastOnline;
                        data.zExponent = data.supervision - data.lastSupervision;
                        data.hExponent = data.blacklist - data.lastBlack;
                        console.log(data.pExponent);
                        this.formData = data;
                    }
                });
            },
            goBusinessList (dataList) {
                this.$router.push({
                    path: '/integrity/businessList',
                    query: {
                        type: dataList
                    }
                });
            },
            // 诚信指数
            getindustryCategory () {
                api.industryCategory().then(res => {
                    if (res.ret === 0) {
                        // for (let i in res.data) {
                        //     res.data[i].select = false;
                        // }
                        console.log('xxxxxxxxxxxxx', res.data);
                        this.navList = [{
                            'code': '',
                            'name': '全部'
                        }, ...res.data];

                        this.$nextTick(() => {
                            this.$refs.tabinfeed.switchTab({
                                'code': '',
                                'name': '全部'
                            }, 0)
                        })
                    }
                });
            },
            getDistribution () {
                let parm = {
                    regionCode: this.authData.integritylimitState.regionCode || '530000', // 地区
                    industryCategory: this.changeCode // 行业类别
                };
                api.distribution(parm).then(res => {
                    if (res.ret === 0) {
                        let data = res.data;
                        // this.pieOption.n1 = Number(data.moreSeven);
                        // this.pieOption.n2 = Number(data.sixToSeven);
                        // this.pieOption.n3 = Number(data.lessSix);
                        this.pieInfeedList = [{
                                                  value: Number(data.moreSeven),
                                                  name: '7分及以上'
                                              },
                                              {
                                                  value: Number(data.sixToSeven),
                                                  name: '≥6分且<7分'
                                              },
                                              {
                                                  value: Number(data.lessSix),
                                                  name: '6分以下(不含)'
                                              }
                        ];
                        setTimeout(() => {
                            this.showIntePie = true
                        }, 50);
                        // console.log(this.pieOption.pieData);
                    }
                });
            },
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 诚信↑↑↑
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////

            // 考核↓↓↓
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            getAssessData (list, data1, data2, state) {
                console.log('list:', list)
                console.log('data1:', data1)
                console.log('data2:', data2)
                console.log('state:', state)
                this.accessState = state
                if (state.assessProviLeader) {
                    this.assesspower = 1
                    this.rankList1 = list.filter(item => {
                        return item.areaType === 1;
                    });
                    this.rankList2 = list.filter(item => {
                        return item.areaType === 2;
                    });
                } else {
                    this.assesspower = 2
                    this.assessment = data1
                    this.ranking = data2
                    this.getScoreData()
                }
            // this.getAssessScoreByDefault();
            },
            getScoreData () {
                apis.accessScore({
                    area: this.accessState.area
                }).then(res => {
                    console.log('resssssssssssssssssssssssssss:', res)
                    this.detailList = res.data.assessScoreInfo.detail
                })
            },
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////
            // 考核↑↑↑
            /// ////////////////////////////////////////////
            /// ////////////////////////////////////////////

            myGuidePendingSincerity (index) {
                this.guideTabIndex = index;
            },

            myTravelPendingSincerity (index) {
                this.travelTabIndex = index;
            }
        },
        mounted () {
            // setTimeout(() => {
            // this.resizeWindow('main1')
            // this.resizeWindow('main2')
            // this.resizeWindow('main3')
            // this.resizeWindow('main4')
            // this.resizeWindow('main5')
            // this.resizeWindow('main6')
            this.on_resizeWindow()
        // }, 500);

        // this.resizeWindow('main2')

        // this.getAssessData();

        // 退货
        // this.getInitTime(this.startTime, this.endTime);
        // this.getInfoList();
        // this.getTrend();
        // 退货
        },
        created () {
            this.swipeTitle = JSON.parse(localStorage.getItem('swipeTitle'))
            console.log('this.swipeTitleeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee:', this.swipeTitle)
            // 权限
            this.authData = JSON.parse(localStorage.getItem('auth'))

            this.swipeTo(Number(localStorage.getItem('swipeTo')))

            // 投诉0
            let cd = JSON.parse(localStorage.getItem('getComplaintData'))
            if (cd) {
                let {
                    handling
                } = cd
                if (handling.length > 0) {
                    this.getComplaintData(cd)
                }
            }

            // 退货2

            if (localStorage.getItem('getRefundData')) {
                this.getRefundData()
            }

            // 诚信3
            if (localStorage.getItem('getIntegrityData')) {
                this.getIntegrityData()
            }

            // 导游4
            let lgd = JSON.parse(localStorage.getItem('loadGuideDataInfeed'))
            if (lgd) {
                let {
                    guideDataInfeed,
                    limitState
                } = lgd
                if (guideDataInfeed || limitState) {
                    this.loadGuideData(guideDataInfeed, limitState)
                }
            }

            // 旅行社5
            let ltd = JSON.parse(localStorage.getItem('loadTravelData'))
            if (ltd) {
                let {
                    datatravel,
                    limitStatetravel
                } = ltd
                if (datatravel || limitStatetravel) {
                    this.loadTravelData(datatravel, limitStatetravel)
                }
            }

            let gd = JSON.parse(localStorage.getItem('getAssessData'))
            if (gd) {
                let {
                    rankClone,
                    assessment,
                    ranking,
                    judgelimitState
                } = gd
                if (rankClone || assessment || ranking || judgelimitState) {
                    // 考核1
                    this.getAssessData(rankClone, assessment, ranking, judgelimitState)
                }
            }
        }
    };
</script>

<style scoped lang="less">
  .infeed-swipe {
    width: 100%;
    height: 100%;
    z-index: 998;
    position: fixed;
    left: 0;
    bottom: 0
  }

  .vcontainer {
    display: flex;
    flex-direction: column;
  }

  .top-contain {
    width: 100%;
    // transform: rotate(90deg);
    height: 44px;
    display: flex;
    padding: 0 16px;
    background: rgba(251, 251, 251, 1);
    border-bottom: 2px solid #eeeeee;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    .top-left {
      display: flex;
      align-items: center;

      .back-icon {
        width: 12px;
        height: 12px;
      }

      .back-icon-big {
        width: 11px;
        height: 16px;
      }

      .title {
        margin-left: 5px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(42, 42, 42, 1);
        line-height: 16px;
      }

      .content {
        margin-right: 1px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 12px;
      }
    }
  }

  .infeed-contain {
    width: 100%;
    height: auto;
    overflow-y: scroll;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    box-sizing: border-box;
    // transform: rotate(90deg);
    background: #ffffff;

    .flex-column {
      flex-direction: column;
    }

    .body-contain {
      display: flex;
      width: 100%;
      height: 330px;
      // position: absolute;
      // top: 44px;
      // bottom: 0;
      // left: 0;

      //投诉
      .left-body {
        width: 221px;
        height: 330px;
        border-right: 1px solid #eeeeee;
        display: flex;
        flex-direction: column;

        .box-margin-complain {
          margin-top: 65px;
        }

        .left-title {
          margin: 19px 0 0 24px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
        }

        .num-body {
          margin-top: 32px;
          display: flex;

          .num-box {
            margin-left: 32px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .num-name {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 12px;
              margin-bottom: 16px;
            }

            .num {
              display: flex;
              align-items: flex-end;
              color: rgba(54, 179, 116, 1);

              .big {
                height: 32px;
                font-size: 32px;
                font-family: DIN-Bold, DIN;
                font-weight: bold;
                color: rgba(54, 179, 116, 1);
                line-height: 32px;
              }

              .small {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(54, 179, 116, 1);
                line-height: 17px;
              }
            }
          }
        }
      }

      .right-body {
        display: flex;
        flex-direction: column;
        padding: 0 23px;
        height: 330px;
        overflow: auto;

        .right-box:last-child {
          border-bottom: 0 !important;
        }

        .right-box {
          // display: flex;
          flex-direction: column;
          border-bottom: 1px solid #eeeeee;

          .title {
            margin-top: 19px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 14px;
          }

          .w-swiper {
            width: 351px;
            min-height: 120px;
            font-family: PingFangSC-Medium, PingFang SC;

            .item {
              min-height: 104px;
              padding: 16px 0 16px 0;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              box-shadow: none;

              .i-title {
                font-size: 16px;
                font-weight: 600;
                color: rgba(54, 179, 116, 1);
              }

              .i-cont {
                font-size: 14px;
                font-weight: 300;
                color: rgba(51, 51, 51, 1);
                line-height: 18px;
              }

              .i-time {
                font-size: 12px;
                font-weight: 300;
                color: rgba(153, 153, 153, 1);
              }
            }
          }

          .w-cont {
            padding: 20px 0 16px 0;
            height: 86px;
            display: flex;
            width: 100%;

            .c-item {
              flex: 1;
              width: 33%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;

              .i-title {
                font-family: PingFangSC-Regular, PingFang SC;
                font-size: 12px;
                color: rgba(51, 51, 51, 1);
              }

              .i-num {
                font-size: 32px;
                font-family: DIN-Bold, DIN;
                font-weight: bold;

                &.d-color {
                  color: rgba(17, 139, 245, 1);
                }

                &.w-color {
                  color: #f75c32;
                }

                &.t-color {
                  color: #ffa509;
                }
              }
            }
          }

          .number-body {
            display: flex;
            padding: 0 12px;
            align-items: center;
            margin-top: 16px;
            margin-bottom: 20px;

            .number-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin: 0 32px;

              .number-title {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 12px;
                margin-bottom: 10px;
              }

              .number-num {
                font-size: 12px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(54, 179, 116, 1);
                line-height: 12px;
              }
            }

            .right-big {
              width: 7px;
              height: 34px;
            }
          }
        }
      }

      // 考核
      .left-text-body {
        border-right: 1px solid #eeeeee;
        display: flex;
        flex-direction: column;
        width: 161px;

        .box-margin-text {
          margin-top: 54px;
        }

        .srore-box {
          display: flex;
          flex-direction: column;
          margin-top: 39px;
          margin-left: 40px;

          .title {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 14px;
          }

          .score {
            margin-top: 8px;
            display: flex;
            align-items: flex-end;

            .nomal {
              height: 32px;
              font-size: 32px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              line-height: 32px;
              margin: 0 4px;
            }

            .small {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }
          }

          .up-down {
            margin-top: 8px;
            display: flex;
            align-items: center;

            .nomal {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }

            .red {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 77, 77, 1);
              line-height: 12px;
              margin-left: 4px;
            }

            .green {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(54, 179, 116, 1);
              line-height: 12px;
              margin-left: 4px;
            }

            .top {
              width: 8px;
              height: 12px;
              margin-left: 2px;
            }
          }
        }
      }

      .right-text-body {
        display: flex;
        width: 505px;
        padding: 0 23px;
        height: 330px;
        overflow: auto;
      }

      .power1box {
        width: 50%;
        padding: 19px 23px 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: 330px;
        overflow: auto;

        .box-margin-test1 {
          margin-top: 30px;
        }

        .title-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 9px;

          .title {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(54, 179, 116, 1);
            line-height: 12px;
          }

          .title-border {
            margin-top: 4px;
            width: 48px;
            height: 2px;
            background: rgba(54, 179, 116, 1);
          }
        }

        .rank-box {
          width: 100%;
        }
      }

      .power-right {
        border-left: 1px solid #eeeeee;
      }

      // 退货
      .back-title {
        margin-top: 19px;
        margin-left: 21px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
      }

      .change-back-contain {
        display: flex;
        padding: 0 24px;
        margin-top: 20px;
        justify-content: center;
        align-items: center;

        .tab-box {
          .t_txt {
            width: 78px;
            height: 32px;
            display: inline-block;
            line-height: 32px;
            text-align: center;
            border: 1px solid #36b374;
            border-right: none;
            font-size: 12px;
            color: #36b374;
          }

          .t_txt:last-child {
            border: 1px solid #36b374;
          }

          .t_active {
            background-color: #36b374;
            color: #fff;
          }
        }

        .switch-box {
          display: flex;
          align-items: center;

          .title {
            margin-right: 8px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .tit {
            font-size: 14px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          }
        }
      }

      .gray-contain {
        margin-top: 20px;
        padding: 0 24px;
        display: flex;
        justify-content: space-between;

        .gray-box {
          width: 303px;
          // height: 96px;

          background: rgba(248, 248, 248, 1);
          border-radius: 1px;
          padding: 0 12px;
          padding-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          .gray-left-box {
            display: flex;
            flex-direction: column;

            .box-title {
              margin-top: 24px;
              margin-bottom: 8px;
              font-size: 14px;
              font-family: PingFang-SC-Bold, PingFang-SC;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
            }

            .box-money {
              margin-top: 8px;
              font-size: 11px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 11px;
            }
          }

          .gray-right-box {
            margin-top: 8px;
            display: flex;
            align-items: flex-end;

            .big {
              height: 32px;
              font-size: 32px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              line-height: 32px;
            }

            .small {
              margin-left: 4px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 12px;
            }
          }
        }
      }

      .white-contain {
        padding: 24px 0;
        margin: 0 24px;
        // display: flex;
        // justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #eeeeee;

        .white-box {
          &:nth-child(1) {
            margin-top: 0;
          }

          &:nth-child(2) {
            margin-top: 0;
          }

          &:nth-child(3) {
            margin-top: 0;
          }

          display: inline-block;
          // flex-direction: column;
          // align-items: center;
          text-align: center;
          margin-top: 24px;
          width: 33.3%;

          .num {
            height: 32px;
            font-size: 32px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            line-height: 32px;
          }

          .content {
            margin-top: 8px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 14px;
          }

          .money {
            margin-top: 8px;
            display: flex;
            justify-content: center;

            .txt {
              border-radius: 1px;
              font-size: 11px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 11px;
              background: rgba(248, 248, 248, 1);
              padding: 8px 12px;
            }

          }
        }
      }

      .refund-cnt {
        padding-left: 24px;
        padding-right: 24px;

        .line-charts {
          margin-top: 23px;
          margin-bottom: 20px;
          font-size: 14px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }

        .line-unit {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }

      // 诚信
      &.sincerity {
        .body-top {
          padding: 0 24px;
          margin-bottom: 30px;
        }

        .body-cont {
          display: flex;
          height: 270px;

          .score-box-item {
            display: flex;
            justify-content: space-between;
          }

          .score-box:last-child {
            margin-bottom: 30px;
          }

          .score-box {
            margin-top: 32px;
            display: flex;

            .s-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              .img{
                vertical-align: middle;
                display: inline-block;
                margin-left: 4px;
                width: 12px;
                height: 12px;
              }
            }

            .s-num {
              margin-top: 8px;
              font-size: 24px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              display: flex;
              align-items: flex-end;

              .n-text {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
              }
            }

            .s-compare {
              margin-top: 8px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #999999;

              .c-text {
                color: #118bf5;

                &.up {
                  color: #36b374;
                }

                &.down {
                  color: #ff4d4d;
                }
              }
            }
          }

          .body-left {
            width: 25%;
            padding-left: 40px;
            height: 270px;
            overflow: auto;

            .total-box {
              display: flex;
              margin-top: 20px;

              .t-title {
                font-size: 14px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);
              }

              .t-num {
                margin-top: 8px;
                font-size: 32px;
                font-family: DIN-Bold, DIN;
                font-weight: bold;
                color: rgba(54, 179, 116, 1);
                display: flex;
                align-items: flex-end;

                .n-text {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                }
              }
            }
          }

          .body-right {
            width: 75%;
            border-left: 1px solid #eeeeee;
            padding: 0 23px;
            display: flex;
            height: 270px;
            overflow: auto;

            .item-box {
              // display: flex;
              border-bottom: 1px solid #eeeeee;
              margin-bottom: 20px;

              &.map {
                height: 250px;
              }

              .i-title {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
              }

              .i-tip {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #999999;
              }

              .i-cont {
                display: flex;
                align-items: center;
                min-height: 184px;

                &.justify-center {
                  justify-content: center;
                }

                .c-left {
                  display: flex;
                  justify-content: center;
                  width: 20%;
                  height: 100px;
                  border-right: 1px solid #eeeeee;

                  .l-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: #333333;
                  }

                  .l-num {
                    font-size: 32px;
                    font-family: DIN-Bold, DIN;
                    font-weight: bold;
                    color: #36b374;
                    display: flex;
                    align-items: flex-end;

                    .n-unit {
                      font-size: 12px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                    }
                  }
                }

                .c-right {
                  height: 100%;
                  width: 80%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
                .line-contain {
                  height: 263px;
                }
              }
            }
          }
        }

        .select_type {
          // margin-top: 10px;
          margin: 24px auto;
          box-sizing: border-box;
          background: #ffffff;
          // padding-left: 20px;

          .t_txt {
            width: 78px;
            height: 32px;
            display: inline-block;
            line-height: 32px;
            text-align: center;
            border: 1px solid #36b374;
            border-right: none;
            font-size: 12px;
            color: #36b374;

            .refund-cnt {
              padding-left: 24px;
              padding-right: 24px;

              .line-charts {
                margin-top: 23px;
                margin-bottom: 20px;
                font-size: 14px;
                font-family: PingFang-SC-Bold, PingFang-SC;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
              }

              .line-unit {
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }

              .line-contain {
                height: 263px;
              }
            }

            .t_txt:last-child {
              border: 1px solid #36b374;
            }

            .t_active {
              background-color: #36b374;
              color: #fff;
            }
          }
        }
      }

      // 导旅
      &.guide {
        .mt40 {
          margin-top: 40px;
        }

        .mt12 {
          margin-top: 12px;
        }

        display: flex;

        .body-left {
          width: 25%;
          display: flex;
          align-items: center;
          overflow: auto;

          .score-box {
            // margin-left: 40px;
            margin-top: 116px;
            display: flex;

            &.mt40 {
              margin-top: 40px;
            }

            .s-num {
              margin-top: 8px;
              font-size: 32px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              display: flex;
              align-items: flex-end;

              .n-text {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
              }
            }

            .s-compare {
              margin-top: 8px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #999999;

              .c-text {
                margin-left: 4px;
                color: #118bf5;

                &.up {
                  color: #36b374;
                }

                &.down {
                  color: #ff4d4d;
                }
              }
            }

            .title {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
            }

            .score {
              margin-top: 8px;
              display: flex;
              align-items: flex-end;

              &.mt40 {
                margin-top: 40px;
              }

              .nomal {
                height: 32px;
                font-size: 32px;
                font-family: DIN-Bold, DIN;
                font-weight: bold;
                color: rgba(54, 179, 116, 1);
                line-height: 32px;
                margin: 0 4px;
              }

              .small {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 12px;
              }
            }
          }
        }

        .body-right {
          width: 75%;
          border-left: 1px solid #eeeeee;
          padding: 0px 24px;
          display: flex;
          overflow: auto;

          .r-cont {
            width: 100%;
            height: 100%;
            display: flex;

            .c-left {
              width: 60%;
              height: 293px;
            }

            .c-right {
              width: 40%;
              margin-top: 20px;
            }
            .line-contain {
                  height: 263px;
            }
          }
        }
      }
    }
  }

  .box {
    margin-top: 32px;
    padding-bottom: 50px;
    width: 100%;
    border-radius: 4px;
    font-size: 0;
    background: #ffffff;

    .left {
      width: 50%;
      height: 100px;
      display: inline-block;
      text-align: center;

    }

    .num-name {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 12px;
      margin-bottom: 16px;
    }

    .num {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      color: rgba(54, 179, 116, 1);

      .big {
        height: 32px;
        font-size: 32px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 32px;
      }

      .small {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);
        line-height: 17px;
      }
    }

  }

  .change-box {
    display: flex;
    align-items: center;
    height: 36px;
    width: 80px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    z-index: 999;
    border: 1px solid rgba(233, 233, 233, 1);
    position: fixed;
    bottom: 12px;
    left: 12px;
    // transform: rotate(90deg);

    .left-change {
      width: 10px;
      height: 14px;
      padding: 11px 14px;
    }

    .border {
      width: 1px;
      height: 28px;
      background: #eeeeee;
    }

    .right-change {
      width: 10px;
      height: 14px;
      padding: 11px 14px;
    }
  }

  .opacity02 {
    opacity: 0.2;
  }

  .opacity1 {
    opacity: 1;
  }

  .line-contain {
    height: 263px;
  }
</style>
